<div class="el-work-wrapper">
    <div class="container">
        <div class="el-work-heading text-center">
            <h4 class="el-top-heading-center">Olympiad Books</h4>
            <!-- <h2 class="el-main-heading">How It Work? Get Your Certificate Now</h2>
            <p class="el-para">Get latest news in your inbox. Consectetur adipiscing elitadipiscing elitse <br>
                ddo eiusmod tempor incididunt ut labore et dolore.</p> -->
        </div>
        <div class="el-team-parent swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <div class="el-team-box">
                        <div class="el-team-box-inner">
                            <div class="flip flip-vertical">
                                <div class="front">
                                    <img src="https://www.silverzone.org/assets/Images/events/Comprehensive-Cover.png"
                                        class="img-fluid">
                                    <h4 class="text-center">Comprehensive Book</h4>
                                </div>
                                <div class="back">
                                    <h4 class="text-center mb-2">Comprehensive Book</h4>
                                    <p>The main benefit of The Book is that it helps students prepare
                                        for Olympiad exams by offering them challenging and stimulating questions.
                                        These questions require students to use abstract thinking and reasoning skills,
                                        essential for solving complex problems... </p>
                                    <a class=" el-btn mt-2" href="https://www.silverzone.org/books?clid=1&cid=1&pt=1"
                                        target="_blank"><span data-hover="Order Now">Order
                                            Now</span></a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="el-team-box">
                        <div class="el-team-box-inner">
                            <div class="flip flip-vertical">
                                <div class="front">
                                    <img src="https://www.silverzone.org/assets/Images/events/Excellence-Guide.png"
                                        class="img-fluid">
                                    <h4 class="mb-2 text-center">Excellence Guide</h4>
                                </div>
                                <div class="back">
                                    <h4>Excellence Guide</h4>
                                    <p>This book covers all the essential topics and concepts that you
                                        need
                                        to master for both national and international
                                        tests. Whether you want to improve your skills, boost your confidence, or
                                        practice
                                        with
                                        realistic questions, this book provides an all-in-one solution...</p>
                                    <a class="btn el-btn mt-2" href="https://www.silverzone.org/books?clid=1&cid=3&pt=1"
                                        target="_blank" tabindex="0"><span data-hover="Order Now">Order
                                            Now</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="el-team-box">
                        <div class="el-team-box-inner">
                            <div class="flip flip-vertical">
                                <div class="front">
                                    <img src="https://www.silverzone.org/assets/Images/events/Previous-Year-Cover.png"
                                        class="img-fluid">
                                    <h4 class="text-center mb-2">Pre.Yr. Q. Paper</h4>
                                </div>
                                <div class="back">
                                    <h4>Pre.Yr. Q. Paper</h4>
                                    <p>The book contains sample questions, solved examples, practice tests
                                        and
                                        tips for the Olympiads. The
                                        student can go through these books to get well acquainted with the format of
                                        SilverZone
                                        Olympiads, gain mastery over
                                        their strategy and
                                        achieve academic excellence...</p>
                                    <a class="el-btn mt-2" href="https://www.silverzone.org/books?clid=1&cid=2&pt=1"
                                        target="_blank" tabindex="0"><span data-hover="Order Now">Order
                                            Now</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="el-team-box">
                        <div class="el-team-box-inner">
                            <div class="flip flip-vertical">
                                <div class="front">
                                    <img src="https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png"
                                        class="img-fluid">
                                    <h4 class="text-center mb-2">Reasoning Guide</h4>
                                </div>
                                <div class="back">
                                    <h4>Reasoning Guide</h4>
                                    <p>The Reasoning Olympiad book is a valuable resource for students who
                                        want to sharpen their reasoning skills and prepare
                                        for reasoning-based competitions. The book covers various topics of logical,
                                        verbal,
                                        non-verbal reasoning, and
                                        provides ample practice exercises and mock tests...</p>
                                    <a class="el-btn mt-2" href="https://www.silverzone.org/books?clid=6&cid=3&sid=10"
                                        target="_blank" tabindex="0"><span data-hover="Order Now">Order
                                            Now</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="el-team-box">
                        <div class="el-team-box-inner">
                            <div class="flip flip-vertical">
                                <div class="front">
                                    <img src="https://www.silverzone.org/assets/Images/events/Instant-Download.png"
                                        class="img-fluid">
                                    <h4 class="text-center mb-2">Instant Download</h4>
                                </div>
                                <div class="back">
                                    <h4>Instant Download</h4>
                                    <p>The question papers from previous years are available to download
                                        in
                                        PDF format on our website. You can download them
                                        and practice them to get familiar with the actual test paper format. This will
                                        help
                                        you
                                        to improve your speed, accuracy,
                                        and confidence...</p>
                                    <a class="el-btn mt-2" target="_blank" tabindex="0"
                                        href="https://www.silverzone.org/books?pt=3"><span data-hover="Download Now">
                                            Download
                                            Now</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide">
                    <div class="el-team-box">
                        <div class="el-team-box-inner">
                            <div class="flip flip-vertical">
                                <div class="front">
                                    <img src="https://www.silverzone.org/assets/Images/events/STEM_9_10.png"
                                        class="img-fluid">
                                    <h4 class="text-center mb-2">STEM Books</h4>
                                </div>
                                <div class="back">
                                    <h4>STEM Books</h4>
                                    <p class="">The book covers a wide range of topics related to STEM, including
                                        physics, chemistry, biology, technology, mathematics, and computer
                                        science. It provides comprehensive content that can help students prepare for
                                        STEM
                                        competitions and exams...</p>
                                    <a class="el-btn mt-2"
                                        href="https://www.silverzone.org/books?clid=3&cid=3&sid=14&pt=1" target="_blank"
                                        tabindex="0"><span data-hover="Order Now">Order
                                            Now</span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="swiper-pagination"></div>
        </div>

        <div class="col-md-12">
            <!-- <div class="row d-flex align-items-center
">

                <div class=" col-lg-3 col-md-4 col-sm-6 d-flex">
                    <div class="flip flip-vertical">
                        <div class="front">
                            <img src="https://www.silverzone.org/assets/Images/events/Comprehensive-Cover.png"
                                class="img-fluid">
                            <h4 class="text-center">Comprehensive Book</h4>
                        </div>
                        <div class="back">
                            <h4 class="text-center mb-2">Comprehensive Book</h4>
                            <p>The main benefit of The Book is that it helps students prepare
                                for Olympiad exams by offering them challenging and stimulating questions.
                                These questions require students to use abstract thinking and reasoning skills,
                                essential for solving complex problems... </p>
                            <a class=" el-btn mt-2" href="https://www.silverzone.org/books?clid=1&cid=1&pt=1"
                                target="_blank"><span data-hover="Order Now">Order
                                    Now</span></a>

                        </div>
                    </div>
                </div>
                <div class=" col-lg-3 col-md-4 col-sm-6 d-flex">
                    <div class="flip flip-vertical">
                        <div class="front">
                            <img src="https://www.silverzone.org/assets/Images/events/Excellence-Guide.png"
                                class="img-fluid">
                            <h4 class="mb-2 text-center">Excellence Guide</h4>
                        </div>
                        <div class="back">
                            <h4>Excellence Guide</h4>
                            <p>This book covers all the essential topics and concepts that you
                                need
                                to master for both national and international
                                tests. Whether you want to improve your skills, boost your confidence, or practice
                                with
                                realistic questions, this book provides an all-in-one solution...</p>
                            <a class="btn el-btn mt-2" href="https://www.silverzone.org/books?clid=1&cid=3&pt=1"
                                target="_blank" tabindex="0"><span data-hover="Order Now">Order
                                    Now</span></a>
                        </div>
                    </div>
                </div>
                <div class=" col-lg-3 col-md-4 col-sm-6 d-flex">
                    <div class="flip flip-vertical">
                        <div class="front">
                            <img src="https://www.silverzone.org/assets/Images/events/Previous-Year-Cover.png"
                                class="img-fluid">
                            <h4 class="text-center mb-2">Pre.Yr. Q. Paper</h4>
                        </div>
                        <div class="back">
                            <h4>Pre.Yr. Q. Paper</h4>
                            <p>The book contains sample questions, solved examples, practice tests
                                and
                                tips for the Olympiads. The
                                student can go through these books to get well acquainted with the format of
                                SilverZone
                                Olympiads, gain mastery over
                                their strategy and
                                achieve academic excellence...</p>
                            <a class="el-btn mt-2" href="https://www.silverzone.org/books?clid=1&cid=2&pt=1"
                                target="_blank" tabindex="0"><span data-hover="Order Now">Order
                                    Now</span></a>
                        </div>
                    </div>
                </div>
                <div class=" col-lg-3 col-md-4 col-sm-6 d-flex">
                    <div class="flip flip-vertical">
                        <div class="front">
                            <img src="https://www.silverzone.org//assets/Images/events/Reasoning-&-Aptitude-02.png"
                                class="img-fluid">
                            <h4 class="text-center mb-2">Reasoning Guide</h4>
                        </div>
                        <div class="back">
                            <h4>Reasoning Guide</h4>
                            <p>The Reasoning Olympiad book is a valuable resource for students who
                                want to sharpen their reasoning skills and prepare
                                for reasoning-based competitions. The book covers various topics of logical, verbal,
                                non-verbal reasoning, and
                                provides ample practice exercises and mock tests...</p>
                            <a class="el-btn mt-2" href="https://www.silverzone.org/books?clid=6&cid=3&sid=10"
                                target="_blank" tabindex="0"><span data-hover="Order Now">Order
                                    Now</span></a>
                        </div>
                    </div>
                </div>
                <div class=" col-lg-3 col-md-4 col-sm-6 d-flex">
                    <div class="flip flip-vertical">
                        <div class="front">
                            <img src="https://www.silverzone.org/assets/Images/events/Instant-Download.png"
                                class="img-fluid">
                            <h4 class="text-center mb-2">Instant Download</h4>
                        </div>
                        <div class="back">
                            <h4>Instant Download</h4>
                            <p>The question papers from previous years are available to download
                                in
                                PDF format on our website. You can download them
                                and practice them to get familiar with the actual test paper format. This will help
                                you
                                to improve your speed, accuracy,
                                and confidence...</p>
                            <a class="el-btn mt-2" target="_blank" tabindex="0"
                                href="https://www.silverzone.org/books?pt=3"><span data-hover="Download Now"> Download
                                    Now</span></a>
                        </div>
                    </div>
                </div>
                <div class=" col-lg-3 col-md-4 col-sm-6 d-flex">
                    <div class="flip flip-vertical">
                        <div class="front">
                            <img src="https://www.silverzone.org/assets/Images/events/STEM_9_10.png" class="img-fluid">
                            <h4 class="text-center mb-2">STEM Books</h4>
                        </div>
                        <div class="back">
                            <h4>STEM Books</h4>
                            <p class="">The book covers a wide range of topics related to STEM, including
                                physics, chemistry, biology, technology, mathematics, and computer
                                science. It provides comprehensive content that can help students prepare for STEM
                                competitions and exams...</p>
                            <a class="el-btn mt-2" href="https://www.silverzone.org/books?clid=3&cid=3&sid=14&pt=1"
                                target="_blank" tabindex="0"><span data-hover="Order Now">Order
                                    Now</span></a>
                        </div>
                    </div>
                </div>



            </div> -->










            <!-- 
            <div class="col-lg-2 col-md-6">
                <div class="el-work-box el-work-box-1">
                    <div class="el-work-box-inner">
                        <div class="el-work-step">
                            <h4>step 01</h4>
                        </div>
                        <div class="el-work-img">
                            <img src="https://www.silverzone.org/assets/Images/events/Comprehensive-Cover.png"
                                alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>Set Your Plan</h4>
                            <p class="el-para">Get latest news in your
                                inbox. Consectet adipiscing
                                elitadipiscing elitseddo.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6">
                <div class="el-work-box el-work-box-2">
                    <div class="el-work-box-inner">
                        <div class="el-work-step">
                            <h4>step 02</h4>
                        </div>
                        <div class="el-work-img">
                            <img src="https://www.silverzone.org/assets/Images/events/Excellence-Guide.png"
                                alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>Find Your Course</h4>
                            <p class="el-para">Get latest news in your
                                inbox. Consectet adipiscing
                                elitadipiscing elitseddo.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6">
                <div class="el-work-box el-work-box-3">
                    <div class="el-work-box-inner">
                        <div class="el-work-step">
                            <h4>step 03</h4>
                        </div>
                        <div class="el-work-img">
                            <img src="https://www.silverzone.org/assets/Images/events/Previous-Year-Cover.png"
                                alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>Book Your Seat</h4>
                            <p class="el-para">Get latest news in your
                                inbox. Consectet adipiscing
                                elitadipiscing elitseddo.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6">
                <div class="el-work-box el-work-box-4">
                    <div class="el-work-box-inner">
                        <div class="el-work-step">
                            <h4>step 04</h4>
                        </div>
                        <div class="el-work-img">
                            <img src="https://www.silverzone.org/assets/Images/events/Reasoning-&-Aptitude-02.png"
                                alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>Get Certificate</h4>
                            <p class="el-para">Get latest news in your
                                inbox. Consectet adipiscing
                                elitadipiscing elitseddo.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6">
                <div class="el-work-box el-work-box-4">
                    <div class="el-work-box-inner">
                        <div class="el-work-step">
                            <h4>step 04</h4>
                        </div>
                        <div class="el-work-img">
                            <img src="https://www.silverzone.org/assets/Images/events/Instant-Download.png"
                                alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>Get Certificate</h4>
                            <p class="el-para">Get latest news in your
                                inbox. Consectet adipiscing
                                elitadipiscing elitseddo.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6">
                <div class="el-work-box el-work-box-4">
                    <div class="el-work-box-inner">
                        <div class="el-work-step">
                            <h4>step 04</h4>
                        </div>
                        <div class="el-work-img">
                            <img src="https://www.silverzone.org/assets/Images/events/STEM_9_10.png" alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>Get Certificate</h4>
                            <p class="el-para">Get latest news in your
                                inbox. Consectet adipiscing
                                elitadipiscing elitseddo.</p>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>